<template>
	<div :class="[companyClass, canScroll]" v-show="userPermissionsFilter.admin">
		<div class="page-mobilemoneyprovider flex column mb-20">
			<div class="page-header">
				<h1 class="pageTitle">Taxes</h1>
				<h4>tax list </h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>settings</el-breadcrumb-item>
					<el-breadcrumb-item>taxes</el-breadcrumb-item>
					<el-breadcrumb-item>view taxes</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="mt-0">
				<div style="float: right;">
					<el-button v-show="userPermissionsFilter.addtaxes" type="primary" icon="el-icon-plus"
						@click="addTax" title="add new tax"></el-button>
				</div>
			</div>


			<resize-observer @notify="handleResize" />
			<div class="table-responsive">
				<table class="table" id="datatable" style="color:white;">
					<thead>
						<tr>
							<th></th>
							<th>Country</th>
							<th>Service Type</th>
							<th>Tax %</th>
							<th>Added On</th>
							<th>Notifications</th>
							<th>Notification Phones</th>
							<th>Notification Emails</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in taxesdata" :key="item.id">
							<td></td>
							<td>{{ item.countryName }}</td>
							<td>{{ item.serviceTypeName }}</td>
							<td>{{ item.percentageStr }}</td>
							<td>{{ formatShortDate(item.createdOn) }}</td>
							<td>{{ item.notificationActive }}</td>
							<td>{{ item.notificationPhoneNumbers }}</td>
							<td>{{ item.notificationEmails }}</td>
							<td v-show="userPermissionsFilter.edittariffs">
								<el-button @click="print(item)" title="view tariff details"><i
										class="mdi mdi-eye"></i></el-button>
								<el-button v-show="userPermissionsFilter.deleteexchangerates" type="danger"
									icon="el-icon-delete" @click="deleteSelectedTariffs(item.id)"></el-button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>


<script>
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import $ from 'jquery';
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'Taxes',
	data() {
		return {
			taxesdata: '',
			deleteIds: []
		}
	},
	methods: {
		addTax() {
			router.push('/addtax');
		},
		deleteSelectedTaxes(selectedIds) {
			this.deleteIds = [selectedIds];
			this.deleteTariffs(this.deleteIds).then(result => {
				if (result) {
					this.refreshTaxes();
				}
			});
		},
		refreshTaxes() {
			this.getTaxes(1, 2000)
				.then((result) => {
					$("#datatable").dataTable().fnDestroy();
					this.taxesdata = result.items;
					this.$nextTick(function () {
						this.initDt()
					});
				})
				.catch((err) => {
					console.log(err)
				});
		},
		print(row) {
			router.push(`/updatetax/${row.id}`);
		},
		initDt() {
			var cmp = this.loggedInCompany.name + " Taxes";
			var cmp_logo = this.loggedInCompany.logo;
			$('#datatable').DataTable({
				dom: 'Blfrtip',
				"pageLength": 10,
				buttons: [
					{
						extend: 'csv',
						messageTop: cmp,
						title: function () {
							return cmp;
						},
					},
					{
						extend: 'pdfHtml5',
						title: function () {
							return cmp;
						},
						orientation: 'portrait',
						pageSize: 'A3', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
						customize: function (doc) {
							doc.defaultStyle.fontSize = 10; //2, 3, 4,etc
							doc.styles.tableHeader.fontSize = 10; //2, 3, 4, etc
						},
						text: '<i class="fa fa-file-pdf-o"> PDF</i>',
						titleAttr: 'PDF',
						messageBottom: 'This report was generated By ' + this.loggedInUser,
					}
				]
			});
		},
	},
	created() {
		this.getLoggedInCompany().then((loggedInCompany) => {
			this.deleteEvent = 'deleteSelectedTaxes';
			this.refreshListEvent = 'refreshTaxes';
			this.$on(this.refreshListEvent, this.refreshTaxes);
			this.$on(this.deleteEvent, this.deleteSelectedTaxes);

			this.refreshTaxes();
		});
	},
	mixins: [PermissionsMixins]
}
</script>

<style lang="scss" scoped></style>